/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */
import FirebaseWrapper from "@/core/js/backend/FIrebaseWrappers/FirebaseWrapper";
import AuthWrapper from "@/core/js/backend/FIrebaseWrappers/AuthWrapper";
import FirestoreWrapper from "@/core/js/backend/FIrebaseWrappers/FirestoreWrapper";
import StorageWrapper from "@/core/js/backend/FIrebaseWrappers/StorageWrapper";

// import firebase from '@firebase/app'

// import '@firebase/auth'
// import '@firebase/firestore'
// import '@firebase/functions'
// import '@firebase/storage'

const config = {
    apiKey: process.env.VUE_APP_FIREBASE_CONFIG_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_CONFIG_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_CONFIG_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_CONFIG_STORAGE_MESSAGINGSENDERID
}

// console.log("config = ", config)

let firebaseWrapper = new FirebaseWrapper(config)

let authWrapper = new AuthWrapper(firebaseWrapper)
let firestoreWrapper = new FirestoreWrapper(firebaseWrapper)
let storageWrapper = new StorageWrapper(firebaseWrapper)

firebaseWrapper.authWrapper = authWrapper
firebaseWrapper.firestoreWrapper = firestoreWrapper
firebaseWrapper.storageWrapper = storageWrapper

let firebase = firebaseWrapper


// firebase.firestore().enablePersistence({synchronizeTabs: true})
// 	.catch(function(err) {
// 		console.error("enablePersistence: err = ", err)
// 		if (err.code == 'failed-precondition') {
// 			// Multiple tabs open, persistence can only be enabled
// 			// in one tab at a a time.
// 			// ...
// 		} else if (err.code == 'unimplemented') {
// 			// The current browser does not support all of the
// 			// features required to enable persistence
// 			// ...
// 		}
// 	});

// firebase utils
const firestore = firebase.firestore()
const storage = firebase.storage()
const auth = firebase.auth()
// const functions = firebase.functions()

// if (location.hostname === "localhost") {
// 	console.log("this is a localhost: process.env.VUE_APP_FIRESTORE_LOCAL = ", process.env.VUE_APP_FIRESTORE_LOCAL)
// 	firestore.settings({
// 		host: process.env.VUE_APP_FIRESTORE_LOCAL,
// 		ssl: false
// 	});
// }

export {
	firebase,
	firestore,
	auth,
	// functions,
	storage
}
